module.exports = __webpack_public_path__ + "static/media/herramienta-gris.d8d04a5d.svg";